import { useEffect, useState } from "react";
import { useTheme, Container, Toolbar, Link, List, ListItem, ListItemButton, ListItemIcon, ListItemText } from "@mui/material";
import { grey } from "@mui/material/colors";
import { House, Person, FileEarmarkSpreadsheet, Basket3, Nut, Truck } from "react-bootstrap-icons";
import { useLocation, Link as ReactRouterLink } from "react-router-dom";
import { INavbarOptions } from "../../../types/molecules";
const Navbar = () => {
  const theme = useTheme();
  const location = useLocation();
  const [active, setActive] = useState("/");
  useEffect(() => {
    setActive(location.pathname.split("/")[1]);
  }, [location]);
  const options: INavbarOptions[] = [{
    label: "Inicio",
    icon: (color: string) => <House color={color} size={22} />,
    path: "/inicio"
  }, {
    label: "Clientes",
    icon: (color: string) => <Person color={color} size={22} />,
    path: "/clientes"
  }, {
    label: "Recibos de caja",
    icon: (color: string) => <FileEarmarkSpreadsheet color={color} size={22} />,
    path: "/recibos"
  }, {
    label: "Remisiones",
    icon: (color: string) => <Truck color={color} size={22} />,
    path: "/remisiones"
  }, {
    label: "Productos",
    icon: (color: string) => <Basket3 color={color} size={22} />,
    path: "/productos"
  }, {
    label: "Mi cuenta",
    icon: (color: string) => <Nut color={color} size={22} />,
    path: "/mi-cuenta"
  }];
  return <Container maxWidth={"sm"} disableGutters sx={{
    marginLeft: 0
  }}>
      <Toolbar component={List} sx={{
      color: grey[700]
    }} disablePadding>
        {options.map(op => {
        const color = active === op.path.substring(1) ? theme.palette.primary.main : grey[700];
        return <ListItem key={`navbarop-${op.label}`} disableGutters sx={{
          marginRight: 2
        }}>
              <Link underline="none" color={color} component={ReactRouterLink} to={op.path}>
                <ListItemButton sx={{
              width: "max-content"
            }}>
                  <ListItemIcon sx={{
                minWidth: 0,
                marginRight: 1
              }}>
                    {op.icon(color)}
                  </ListItemIcon>
                  <ListItemText>{op.label}</ListItemText>
                </ListItemButton>
              </Link>
            </ListItem>;
      })}
      </Toolbar>
    </Container>;
};
export default Navbar;